import React from "react";
import { OperationStepPayload, BookingStatus, TripStatus } from "../../service/interfaces/Pickup.interface";
import DatePicker from "../Datepicker";
import Input from "../FormInputs";
import CustomDropDown from "../Dropdown/CustomDropDown";

export type PickupOutFormProps = {
    value: OperationStepPayload;
    onChange: (payload: OperationStepPayload) => void;
    onSubmit: () => void;
    submitting?: boolean;
    bookingStatus?: BookingStatus;
    tripStatus?: TripStatus;
    onBookingStatusChange?: (status: BookingStatus) => void;
    onTripStatusChange?: (status: TripStatus) => void;
};

export const PickupOutForm: React.FC<PickupOutFormProps> = ({
    value,
    onChange,
    onSubmit,
    submitting,
    bookingStatus,
    tripStatus,
    onBookingStatusChange,
    onTripStatusChange
}) => {
    const updateField = (field: Partial<OperationStepPayload>) => onChange({ ...value, ...field });

    const statusOptions = [
        { label: "Select Status", value: "" },
        { label: "Cancel", value: "cancel" },
        { label: "Hold", value: "hold" },
        { label: "Completed", value: "completed" }
    ];

    return (
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
            <div className="grid grid-cols-12 gap-4 items-start">
                <div className="col-span-12 md:col-span-6">
                    <DatePicker
                        label="Date & Time"
                        name="operationOutDate"
                        onDateChange={(d: string) => {
                            const date = new Date(d);
                            updateField({ dateISO: d.slice(0, 10), timeISO: date.toISOString() });
                        }}
                        defaultValue={value.timeISO}
                        includeTime={true}
                        register={{}}
                        errors={{}}
                        allowPastDates={true}
                    />
                </div>
                <div className="col-span-12 md:col-span-6">
                    <Input
                        label="Odo KM"
                        name="odoKmOut"
                        type="number"
                        placeholder="Enter odometer km"
                        errors={{}}
                        register={() => ({})}
                        onChange={(v) => updateField({ odoKm: Number(v) || 0 })}
                        value={value.odoKm?.toString() || ''}
                    />
                </div>
                <div className="col-span-12 md:col-span-6">
                    <CustomDropDown
                        label="Booking Status"
                        name="bookingStatusOut"
                        options={statusOptions}
                        register={() => ({})}
                        errors={{}}
                        defaultValue={bookingStatus || ""}
                        placeholder="Select booking status"
                        onChange={(value) => onBookingStatusChange?.(value as BookingStatus)}
                    />
                </div>
                <div className="col-span-12 md:col-span-6">
                    <CustomDropDown
                        label="Trip Status"
                        name="tripStatusOut"
                        options={statusOptions}
                        register={() => ({})}
                        errors={{}}
                        defaultValue={tripStatus || ""}
                        placeholder="Select trip status"
                        onChange={(value) => onTripStatusChange?.(value as TripStatus)}
                    />
                </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
                <button type="submit" disabled={submitting} className="w-36 h-8 rounded-lg bg-[#444FBD] text-white transition duration-200 hover:bg-opacity-90 text-sm">Complete</button>
            </div>
        </form>
    );
};


